import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="shopbridgemarket" link="https://shopbridgemarket.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This project is based on react,commerce.js and stripe.js.In here we can have
  exclusive ecommerce experience..
    </ProjectCard>
    <ProjectCard title="Memories-Creator" link="https://memories-creator.netlify.app/" bg="linear-gradient(to right, #00ff00 0%, #ffff00
 100%)" mdxType="ProjectCard">
  This project created using React,Node.js and Express.Over here we can create
  and modify our beautiful memories..
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      